
/* styles */
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4dd59f68\",\"scoped\":false,\"hasInlineConfig\":false}!stylus-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./werven.vue")
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-4dd59f68\",\"scoped\":true,\"hasInlineConfig\":false}!../node_modules/vue-loader/lib/selector?type=styles&index=1!./werven.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./werven.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4dd59f68\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!./werven.vue"),
  /* scopeId */
  "data-v-4dd59f68",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/werven.vue
// module id = 39
// module chunks = 3